import {Configuration} from '@api';

export const apiConfiguration = new Configuration({basePath: process.env.NUXT_PUBLIC_BACKEND_HOST || ''});
